import {useCallback, useEffect, useReducer} from 'react';

import {AnimatedGame, animationReducer, createAnimatedGame, settleDuration, slideDuration} from './animation';
import {createGame, Direction} from './game';

interface AnimatedGameControls extends AnimatedGame {
    move(direction: Direction): void;
    restart(): void;
}

/** Advance slide/merge phases and cancel pending work on restart or unmount. */
export const useAnimatedGame = (): AnimatedGameControls => {
    const [state, dispatch] = useReducer(animationReducer, undefined, () => createAnimatedGame());

    useEffect(() => {
        if (state.phase === 'idle') return;
        const sliding = state.phase === 'sliding';
        const timer = window.setTimeout(() => {
            dispatch({type: sliding ? 'finishSlide' : 'finishSettle'});
        }, sliding ? slideDuration : settleDuration);

        return () => window.clearTimeout(timer);
    }, [state.phase]);

    const move = useCallback((direction: Direction): void => {
        dispatch({
            type: 'move',
            input: {
                direction,
                randomPosition: Math.random(),
                randomValue: Math.random(),
                animate: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
            },
        });
    }, []);
    const restart = useCallback(() => dispatch({type: 'restart', game: createGame()}), []);

    return {...state, move, restart};
};
